import { Controller } from "@hotwired/stimulus"
import Chart from 'chart.js/auto'
import { Colors } from "chart.js"

// Connects to data-controller="section-chart"
export default class extends Controller {
  static targets = [ "canvas" ]
  static values = {
    type: String,
    data: String
  }

  connect() {
    this.initChart()
  }

  disconnect() {
    if (this._chart) {
      this._chart.destroy()
    }
  }

  initChart() {
    const scalesConfig = ["line", "bar"].includes(this.typeValue)
      ? {
          y: {
            beginAtZero: true
          }
        }
      : {}

    this._chart = new Chart(
      this.canvasTarget,
      {
        type: this.typeValue,
        data: JSON.parse(this.dataValue),
        options: {
          animation: {
            duration: 0,            // Disables the animation
          },
          transitions: {
            active: {
              animation: {
                duration: 0         // Disables the hover animation
              }
            }
          },
          responsive: false,
          maintainAspectRatio: true,
          scales: scalesConfig,
          plugins: {
            legend: {
              display: ["pie", "doughnut"].indexOf(this.typeValue) > -1
            }
          }
        }
      }
    )
  }
}
